import { Spinner } from '@mgh-app/component-library';
import { useAuth } from 'auth/useAuth';
import { FC, PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import { useGetConsentQuery } from 'services/HomeManagementApi/UnitsManagementService';

export const ConsentRoute: FC<PropsWithChildren> = ({ children }) => {
  const { user } = useAuth();
  const { data, isLoading } = useGetConsentQuery({ unitId: user?.unitId ?? '' });

  if (isLoading) return <Spinner />;

  if (!isLoading && !data) return <>{children}</>;

  return data && !data.userId ? <Navigate to="/consent" replace /> : <>{children}</>;
};
